export default __webpack_public_path__ + "static/compare-content-a10a3568ef8c085a3930b6924e934fc2.png";